import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
export const Checkbox = React.forwardRef(function Checkbox({ label, description, className, id, ...rest }, ref) {
    return (_jsxs("label", { className: className, "data-checkbox": true, htmlFor: id, style: {
            display: 'flex',
            alignItems: 'flex-start',
            gap: 'var(--space-3)',
            padding: 'var(--space-2)',
            minHeight: 'var(--min-touch-target)',
            cursor: 'pointer',
            color: 'var(--text)',
            fontFamily: 'var(--font-ui)',
            fontSize: 'var(--font-size-2xs)',
        }, children: [_jsx("input", { ref: ref, type: "checkbox", id: id, style: { width: '18px', height: '18px', marginTop: '2px', accentColor: 'var(--accent)' }, ...rest }), _jsxs("span", { style: { display: 'grid', gap: '2px' }, children: [_jsx("span", { children: label }), description ? (_jsx("span", { style: { color: 'var(--text-dim)', fontSize: 'var(--font-size-3xs)' }, children: description })) : null] })] }));
});
//# sourceMappingURL=Checkbox.js.map